// src/App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import TagManager from 'react-gtm-module';
import AppRoutes from './routes/index';
import { UserTrackingProvider } from './contexts/UserTrackingContext';
const tagManagerArgs = {
  gtmId: 'GTM-PR8QM84F', // your GTM ID
};

// Component to track page views on route changes
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: location.pathname + location.search,
        title: document.title,
      },
    });
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize GTM on app mount
    TagManager.initialize(tagManagerArgs);
    
    // Optional: Log initialization for debugging
    console.log('GTM initialized with ID:', tagManagerArgs.gtmId);
  }, []);

  return (
    <UserTrackingProvider>
    <HelmetProvider>
      <BrowserRouter>
        <PageTracker />
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
    </UserTrackingProvider>
  );
}

export default App;